import React from "react";
import css from "./Homepage.module.css";
import ParticleBackground from "./ParticleBackground";
import Footer from "./Footer";
import PanelHP from "./PanelsHP/PanelHP";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

const Homepage = () => {
  let navigate = useNavigate();
  
  return (
    <div>
      <ParticleBackground />
      <div className={css.homepage}>
        <div className={css.title}>itGraph</div>
        <PanelHP />
        <Footer />
      </div>
      <FontAwesomeIcon
        className={css.tutorial}
        icon="fa-info"
        color="#383838"
        title={
          "Info: tutorial"
        }
        onClick={() => navigate("/tutorial")}
      />
    </div>
  );
};

export default Homepage;
